import Vue from 'vue';
import Router from 'vue-router';
import Meta from 'vue-meta';

// Static Routes
import PrimaryNav from './components/core/PrimaryNavigation.vue';
import PrimaryFooter from './components/core/PrimaryFooter.vue';
// import PromotionalBanner from './components/core/PromotionalBanner.vue';
import Blank from './views/Blank.vue';
import NotFound from './views/NotFound.vue';

import PrimaryNavSpecial from './views/blackfriday/PrimaryNavSpecial.vue';

import PrimaryNavChinese from './views/chinese/PrimaryNavChinese.vue';

Vue.use(Router);
Vue.use(Meta);

// Home
const Home = () => import('./views/Home.vue' /* webpackChunkName: "home-eng" */);

// fusionchat chatbox
const Chatapp = () => import('./views/chatbox/ChatApp.vue' /* webpackChunkName: "pricing" */);

// Chinese Home
const ChineseHome = () =>
   import('./views/chinese/chinese-landing.vue' /* webpackChunkName: "home-chinese" */);

// About & Contact
const About = () => import('./views/About.vue' /* webpackChunkName: "about" */);
const PrivacyPolicy = () =>
   import('./views/PrivacyPolicy.vue' /* webpackChunkName: "PrivacyPolicy" */);
const Partners = () => import('./views/Partners.vue' /* webpackChunkName: "Partners" */);
const Contact = () => import('./views/Contact.vue' /* webpackChunkName: "Contact" */);
const ContactThankYou = () => import('./views/ContactThankYou');
const QuoteThankYou = () => import('./views/QuoteThankYou');
const WPThankYou = () => import('./views/WPThankYou');
const ThankYouUni = () => import('./views/ThankYouUni');
const ThankYouData = () => import('./views/ThankYouData');
// const SubscriptionThankYou = () => import('./views/SubscriptionThankYou');
// const NewsletterSignup = () => import('./views/NewsletterSignup.vue');
const Support = () => import('./views/ContactSupport.vue' /* webpackChunkName: "Support" */);
const Sales = () => import('./views/ContactSales.vue' /* webpackChunkName: "Sales" */);
const Career = () => import('./views/Career.vue' /* webpackChunkName: "Career" */);
const Team = () => import('./views/Team.vue' /* webpackChunkName: "team" */);

// for Comparison nwq //
const Comparison = () => import('./views/Comparison.vue' /* webpackChunkName: "comparison" */);
// const ComparisonDetailed = () =>
// import('./views/comparison/Detailed.vue' /* webpackChunkName: "comparison" */);
const ComparisonFCDetails = () =>
   import('./views/comparison/ComparisonFCDetails.vue' /* webpackChunkName: "comparison" */);
// Black Friday Landing Page
const BlackFriday = () =>
   import('./views/blackfriday/BlackFriday.vue' /* webpackChunkName: "blackfriday" */);
const SankeySample = () =>
   import('./views/blackfriday/SankeySample.vue' /* webpackChunkName: "blackfriday" */);

const SideBar = () => import('./components/core/SideBar.vue');

// Pricing & EULA & Verify Order
// const Pricing = () => import('./views/pricing/Landing.vue' /* webpackChunkName: "pricing" */);
const PricingSupport = () => import('./views/PricingSupport.vue' /* webpackChunkName: "pricing" */);
// const EulaPerpetual = () =>
// import('./views/pricing/EulaPerpetual.vue' /* webpackChunkName: "pricing" */);
// const VerifyOrder = () =>
// import('./views/pricing/VerifyOrder.vue' /* webpackChunkName: "pricing" */);

// const BuyNowThankyou = () =>
// import('./views/pricing/BuyNowThankyou.vue' /* webpackChunkName: "pricing" */);

// Explore
// const Explore = () => import('./views/Explore.vue' /* webpackChunkName: "explore" */ );
const ChartGalleryOverview = () =>
   import('./views/chart-gallery/Overview.vue' /* webpackChunkName: "ChartGalleryDetailsNew" */);
const ChartGalleryTypeOverview = () =>
   import(
      './views/chart-gallery/ChartTypeOverview.vue' /* webpackChunkName: "ChartGalleryDetailsNew" */
   );

const ChartGalleryDetailsNew = () =>
   import('./views/chart-gallery/Details.vue' /* webpackChunkName: "ChartGalleryDetailsNew" */);
const IntegrationsOverview = () =>
   import('./views/integrations/Overview.vue' /* webpackChunkName: "Integrations" */);
const IntegrationsDetails = () =>
   import('./views/integrations/Details.vue' /* webpackChunkName: "Integrations" */);
const FlutterIntegrationsDetails = () =>
   import('./views/integrations/FlutterDetails.vue' /* webpackChunkName: "FlutterIntegrations" */);
// const BlazorIntegrationsDetails = () =>
// import('./views/pricing/LandingLife.vue' /* webpackChunkName: "Integrations" */);
const AccessibilityOverview = () =>
   import('./views/accessibility/Overview.vue' /* webpackChunkName: "Accessibility" */);
const AccessibilityDetails = () =>
   import('./views/accessibility/Details.vue' /* webpackChunkName: "Accessibility" */);
const ChartGuideDetails = () =>
   import('./views/chart-guide/Details.vue' /* webpackChunkName: "chart-guide" */);

// Maps
// TODO - merge into explore
const MapOverview = () => import('./views/maps/Overview.vue' /* webpackChunkName: "map" */);
const MapDetails = () => import('./views/maps/Details.vue' /* webpackChunkName: "map" */);

// Resources & Reseller
const Resource = () =>
   import('./views/resources/ResourceLanding.vue' /* webpackChunkName: "reseller" */);
const ResourceDetails = () =>
   import('./views/resources/ResourceDetails.vue' /* webpackChunkName: "reseller" */);
const ResellersLanding = () =>
   import('./views/resellers/ResellersLanding.vue' /* webpackChunkName: "reseller" */);
const ResellerDetails = () =>
   import('./views/resellers/ResellerDetails.vue' /* webpackChunkName: "reseller" */);

// Dashboard, Data Stories & Export
const Dashboard = () =>
   import('./views/dashboard/DashboardLanding.vue' /* webpackChunkName: "dashboard" */);
const DashboardDetails = () =>
   import('./views/dashboard/DashboardDetails.vue' /* webpackChunkName: "dashboard" */);
const FusionExport = () =>
   import('./views/fusionexport/FusionExport.vue' /* webpackChunkName: "dashboard" */);
const DataStoryOverview = () =>
   import('./views/data-story/Overview.vue' /* webpackChunkName: "dashboard" */);
const DataStory = () =>
   import('./views/data-story/Details.vue' /* webpackChunkName: "dashboard" */);

// Download
const Download = () => import('./views/Download.vue' /* webpackChunkName: "download" */);
const TrialThankYouSuite = () =>
   import('./views/TrialThankYouSuite.vue' /* webpackChunkName: "download" */);
const WhitepaperTemplate = () =>
   import('./views/resources/WhitepaperPdfDetails.vue' /* whitepaper download pdf: "download" */);
const WhitepaperTemplatePdf = () =>
   import('./views/resources/WhitepaperDetailsPdf.vue' /* whitepaper download pdf: "download" */);
const TrialThankYouTime = () =>
   import('./views/TrialThankYouTime.vue' /* webpackChunkName: "download" */);
const TrialThankYouGrid = () =>
   import('./views/TrialThankYouGrid.vue' /* webpackChunkName: "download" */);
const TrialThankYouExport = () =>
   import('./views/TrialThankYouExport.vue' /* webpackChunkName: "download" */);
const ResellersFaqs = () => import('./views/ResellersFaqs.vue' /* webpackChunkName: "download" */);

// Customers
const Customers = () =>
   import('./views/customer/CustomerLanding.vue' /* webpackChunkName: "customers" */);
const CutomerDetails = () =>
   import('./views/customer/CustomerDetails.vue' /* webpackChunkName: "customers" */);

// const NonCommercial = () =>
// import('./views/NonCommercial.vue' /* webpackChunkName: "NonCommercial" */);

// Product Gallery Page
const ProductGallery = () =>
   import('./views/ProductGallery.vue' /* webpackChunkName: "customers" */);

// featureGallery
const featureGalleryLanding = () =>
   import(
      './views/feature-gallery/FeatureGalleryLanding.vue' /* webpackChunkName: "featureGallery" */
   );
const featureGalleryDetailed = () =>
   import(
      './views/feature-gallery/FeatureGalleryDetailed.vue' /* webpackChunkName: "featureGallery" */
   );

// Fusion Time
const fusionTimeOverview = () =>
   import('./views/fusion-time/Overview.vue' /* webpackChunkName: "fusionTimeOverview" */);
const fusionTimeExamples = () =>
   import('./views/fusion-time/Examples.vue' /* webpackChunkName: "fusionTimeExamples" */);
const fusionTimeDetails = () =>
   import('./views/fusion-time/Details.vue' /* webpackChunkName: "fusionTimeDetails" */);

// Fusion Grid

const FusionGrid = () =>
   import('./views/fusion-grid/Overview.vue' /* webpackChunkName: "fusiongrid" */);
const FusionGridOld = (/* webpackChunkName: "fusiongrid" */) =>
   './views/fusion-grid/Overviewold.vue';
const fusionGridDetails = () =>
   import('./views/fusion-grid/Details.vue' /* webpackChunkName: "fusiongrid" */);
const FusionGridThankYou = () =>
   import('./views/fusion-grid-thank-you.vue' /* webpackChunkName: "fusiongrid" */);

// Admin
const Admin = () => import('./views/Admin.vue' /* webpackChunkName: "admin" */);

const FusionTimeDemo = () =>
   import('./views/showcases/FusionTimeDemo.vue' /* webpackChunkName: "FusionTimeDemo" */);

// comparison
// const ComparisonOverview = () =>
//  import('./views/comparison/Overview.vue' /* webpackChunkName: "chart-guide" */);

// Live demo gallery
const DemoGallery = () =>
   import('./views/demo-gallery/DemoGallery.vue' /* webpackChunkName: "demo-gallery" */);
export default function createRouter() {
   return new Router({
      mode: 'history',
      fallback: false,
      scrollBehavior(to, from, savedPosition) {
         if (to.hash) {
            if (to.path === from.path) return null;
            return {
               selector: to.hash,
            };
         }

         if (to.path === from.path) return null;

         if (savedPosition) {
            return savedPosition;
         }

         return {
            x: 0,
            y: 0,
         };
      },
      routes: [
         {
            path: '/',
            components: {
               default: Home,
               // promotionalBanner: PromotionalBanner,
               primaryNavigation: PrimaryNav,
               primaryFooter: PrimaryFooter,
            },
         },
         {
            name: 'askfusiondev-ai',
            path: '/askfusiondev-ai',
            components: {
               default: Chatapp,
               primaryNavigation: PrimaryNav,
               primaryFooter: PrimaryFooter,
               // sideBar: ChatboxSideBar,
            },
         },
         {
            path: '/cn',
            components: {
               default: ChineseHome,
               primaryNavigation: PrimaryNavChinese,
               primaryFooter: PrimaryFooter,
            },
         },
         {
            path: '/releases/introducing-sankey-chord-sunburst-and-realtime-charts',
            components: {
               default: BlackFriday,
               primaryNavigation: PrimaryNavSpecial,
            },
         },
         {
            path: '/releases/explore-sankey',
            components: {
               default: SankeySample,
               primaryNavigation: PrimaryNavSpecial,
            },
         },

         {
            path: '/dashboards',
            components: {
               default: Blank,
               primaryNavigation: PrimaryNav,
               primaryFooter: PrimaryFooter,
               sideBar: SideBar,
            },
            children: [
               {
                  name: 'dashboards-landing',
                  path: '',
                  component: Dashboard,
               },
               {
                  name: 'dashboards-detail',
                  path: ':slug',
                  component: DashboardDetails,
               },
            ],
         },
         {
            path: '/datastories',
            components: {
               default: Blank,
               primaryNavigation: PrimaryNav,
               primaryFooter: PrimaryFooter,
               sideBar: SideBar,
            },
            children: [
               {
                  name: 'data-stories-landing',
                  path: '',
                  component: DataStoryOverview,
               },
               {
                  name: 'data-stories-detail',
                  path: ':name',
                  component: DataStory,
               },
            ],
         },
         {
            path: '/fusiontime',
            components: {
               default: Blank,
               primaryNavigation: PrimaryNav,
               primaryFooter: PrimaryFooter,
               sideBar: SideBar,
            },
            children: [
               {
                  name: 'fusion-time-overview',
                  path: '',
                  component: fusionTimeOverview,
               },
               {
                  name: 'fusion-time-examples',
                  path: 'examples',
                  component: fusionTimeExamples,
               },

               {
                  name: 'fusion-time-details',
                  path: 'examples/:slug',
                  component: fusionTimeDetails,
               },
            ],
         },
         {
            name: 'fusion-time-demo',
            path: '/fusiontime/demo',
            components: {
               default: FusionTimeDemo,
               primaryNavigation: PrimaryNav,
            },
         },
         {
            path: '/fusiongrid-details',
            components: {
               default: FusionGridOld,
               primaryNavigation: PrimaryNav,
               primaryFooter: PrimaryFooter,
            },
         },
         {
            path: '/fusiongrid',
            components: {
               default: Blank,
               primaryNavigation: PrimaryNav,
               primaryFooter: PrimaryFooter,
               sideBar: SideBar,
            },
            children: [
               {
                  name: 'fusion-grid-overview',
                  path: '',
                  component: FusionGrid,
               },
               {
                  name: 'fusion-grid-examples',
                  path: 'examples',
                  component: FusionGrid,
               },

               {
                  name: 'fusion-grid-details',
                  path: 'examples/:slug',
                  component: fusionGridDetails,
               },
            ],
         },
         /* {
            path: '/fusiongridtest',
            components: {
               default: FusionGridtest,
               primaryNavigation: PrimaryNav,
               primaryFooter: PrimaryFooter,
            },
         }, */
         {
            path: '/fusiongrid/thank-you',
            components: {
               default: FusionGridThankYou,
               primaryNavigation: PrimaryNav,
               primaryFooter: PrimaryFooter,
            },
         },
         {
            path: '/features',
            components: {
               default: Blank,
               primaryNavigation: PrimaryNav,
               primaryFooter: PrimaryFooter,
               sideBar: SideBar,
            },
            children: [
               {
                  name: 'feature-gallery-landing',
                  path: '',
                  component: featureGalleryLanding,
               },
               {
                  name: 'feature-gallery-detailed',
                  path: ':slug',
                  component: featureGalleryDetailed,
                  props: {
                     default: {
                        sidebarClass: 'chart-guide',
                     },
                  },
               },
            ],
         },

         {
            path: '/fusionmaps',
            components: {
               default: Blank,
               primaryNavigation: PrimaryNav,
               primaryFooter: PrimaryFooter,
               sideBar: SideBar,
            },
            children: [
               {
                  name: 'map-gallery',
                  path: ':map?',
                  component: MapOverview,
               },
               {
                  name: 'map-gallery-details',
                  path: ':type/:name',
                  component: MapDetails,
               },
            ],
         },
         {
            path: '/charts',
            components: {
               default: Blank,
               primaryNavigation: PrimaryNav,
               primaryFooter: PrimaryFooter,
               sideBar: SideBar,
            },
            children: [
               {
                  name: 'charts-landing',
                  path: '',
                  component: ChartGalleryOverview,
               },
               {
                  name: 'charts-overview',
                  path: ':type',
                  component: ChartGalleryTypeOverview,
               },

               {
                  name: 'charts-detail-new',
                  path: ':type/:name',
                  component: ChartGalleryDetailsNew,
               },
            ],
         },
         {
            path: '/fusionexport',
            name: 'fusionexport',
            components: {
               default: FusionExport,
               primaryNavigation: PrimaryNav,
               primaryFooter: PrimaryFooter,
               sideBar: SideBar,
            },
         },
         {
            path: '/extensions/accessibility',
            components: {
               default: Blank,
               primaryNavigation: PrimaryNav,
               primaryFooter: PrimaryFooter,
               sideBar: SideBar,
            },
            children: [
               {
                  name: 'accessibility-overview',
                  path: '',
                  component: AccessibilityOverview,
               },
               {
                  name: 'accessibility-details',
                  path: ':slug',
                  component: AccessibilityDetails,
               },
            ],
         },
         {
            path: '/contact-us',
            component: Contact,
            components: {
               default: Contact,
               primaryNavigation: PrimaryNav,
               primaryFooter: PrimaryFooter,
            },
         },
         {
            path: '/contact-us/thank-you',
            components: {
               default: ContactThankYou,
               primaryNavigation: PrimaryNav,
               primaryFooter: PrimaryFooter,
            },
         },
         {
            path: '/quote/thank-you',
            components: {
               default: QuoteThankYou,
               primaryNavigation: PrimaryNav,
               primaryFooter: PrimaryFooter,
            },
         },
         {
            path: '/whitepaper/thank-you',
            components: {
               default: WPThankYou,
               primaryNavigation: PrimaryNav,
               primaryFooter: PrimaryFooter,
            },
         },
         {
            path: '/thank-you',
            components: {
               default: ThankYouUni,
               primaryNavigation: PrimaryNav,
               primaryFooter: PrimaryFooter,
            },
         },
         {
            path: '/data/thank-you',
            components: {
               default: ThankYouData,
               primaryNavigation: PrimaryNav,
               primaryFooter: PrimaryFooter,
            },
         },
         {
            path: '/contact-sales',
            component: Sales,
            components: {
               default: Sales,
               primaryNavigation: PrimaryNav,
               primaryFooter: PrimaryFooter,
            },
         },

         {
            path: '/careers',
            component: Career,
            components: {
               default: Career,
               primaryNavigation: PrimaryNav,
               primaryFooter: PrimaryFooter,
            },
         },
         {
            path: '/contact-support',
            component: Support,
            components: {
               default: Support,
               primaryNavigation: PrimaryNav,
               primaryFooter: PrimaryFooter,
            },
         },
         {
            path: '/about-us',
            components: {
               default: About,
               primaryNavigation: PrimaryNav,
               primaryFooter: PrimaryFooter,
            },
         },
         {
            path: '/team',
            components: {
               default: Team,
               primaryNavigation: PrimaryNav,
               primaryFooter: PrimaryFooter,
            },
         },
         {
            path: '/compare/fusioncharts-vs-highcharts',
            name: 'fusioncharts-vs-highchartss',
            components: {
               default: Comparison,
               primaryNavigation: PrimaryNav,
               primaryFooter: PrimaryFooter,
            },
         },
         {
            path:
               '/compare/:slug(fusioncharts-vs-d3|fusioncharts-vs-amcharts|fusioncharts-vs-chartjs)',
            components: {
               default: ComparisonFCDetails,
               primaryNavigation: PrimaryNav,
               primaryFooter: PrimaryFooter,
            },
         },

         /* {
            path: '/javascript-charting-comparison',
            components: {
               default: Blank,
               primaryNavigation: PrimaryNav,
               primaryFooter: PrimaryFooter,
            },
            children: [
               {
                  name: 'comparison-overview',
                  path: '',
                  component: ComparisonOverview,
               },
               {
                  path: 'fusioncharts-vs-highcharts',
                  name: 'fusioncharts-vs-highcharts',
                  component: Comparison,
               },
               {
                  path: 'fusioncharts-vs-google-charts',
                  name: 'fusioncharts-detailed-comparison',
                  component: () => import('./views/comparison/FCDetails.vue'),
                  props: {
                     product: 'google-charts',
                  },
               },
               {
                  path: 'fusioncharts-vs-chartjs',
                  name: 'fusioncharts-detailed-comparison-chartjs',
                  component: () => import('./views/comparison/FCDetails.vue'),
                  props: {
                     product: 'chartjs',
                  },
               },

               {
                  path: ':slug',
                  name: 'detailed-comparison',
                  component: ComparisonDetailed,
               },
            ],
         }, */

         // {
         //    path: '/javascript-charting-comparison/fusioncharts-vs-highcharts',
         //    name: 'fusioncharts-vs-highcharts',
         //    components: {
         //       default: Comparison,
         //       primaryNavigation: PrimaryNav,
         //       primaryFooter: PrimaryFooter,
         //    },
         // },
         /* {
            path: '/buy',
            components: {
               default: Blank,
               primaryNavigation: PrimaryNav,
               primaryFooter: PrimaryFooter,
            },
            props: {
               primaryNavigation: {
                  isLight: true,
               },
            },
            children: [
               {
                  path: '',
                  component: Pricing,
               },
               {
                  path: 'verify',
                  redirect: {
                     path: 'verify/perpetual/developer',
                  },
               },
               {
                  path: 'verify/perpetual',
                  redirect: {
                     path: 'verify/perpetual/developer',
                  },
               },
               {
                  path: 'verify/:type/:license',
                  component: VerifyOrder,
                  props: true,
               },
               {
                  path: 'verify/:type/:license',
                  component: VerifyOrder,
                  props: true,
               },
               {
                  path: 'verify/:type/:license/:support',
                  component: VerifyOrder,
                  props: true,
               },
               {
                  path: 'eula-perpetual',
                  component: EulaPerpetual,
                  props: true,
               },
               {
                  path: 'thankyou',
                  component: BuyNowThankyou,
                  props: true,
               },
            ],
         }, */
         {
            path: '/support',
            components: {
               default: PricingSupport,
               primaryNavigation: PrimaryNav,
               primaryFooter: PrimaryFooter,
            },
         },
         {
            path: '/fusioncharts',
            components: {
               default: ProductGallery,
               primaryNavigation: PrimaryNav,
               primaryFooter: PrimaryFooter,
               sideBar: SideBar,
            },
         },
         {
            path: '/resources',
            components: {
               default: Blank,
               primaryNavigation: PrimaryNav,
               primaryFooter: PrimaryFooter,
            },
            children: [
               {
                  path: '',
                  components: {
                     default: Resource,
                     primaryNavigation: PrimaryNav,
                     primaryFooter: PrimaryFooter,
                  },
               },
               {
                  path: ':section/:slug',
                  components: {
                     default: ResourceDetails,
                     primaryNavigation: PrimaryNav,
                     primaryFooter: PrimaryFooter,
                  },
               },
            ],
         },
         {
            path: '/customers',
            components: {
               default: Customers,
               primaryNavigation: PrimaryNav,
               primaryFooter: PrimaryFooter,
            },
         },
         {
            path: '/customers/:slug',
            components: {
               default: CutomerDetails,
               primaryNavigation: PrimaryNav,
               primaryFooter: PrimaryFooter,
            },
         },
         {
            path: '/buy/resellers',
            components: {
               default: ResellersLanding,
               primaryNavigation: PrimaryNav,
               primaryFooter: PrimaryFooter,
            },
         },
         {
            path: '/buy/resellers/contact',
            redirect: {
               path: '/buy/resellers/',
            },
         },
         {
            path: '/buy/resellers/contact/:slug',
            components: {
               default: ResellerDetails,
               primaryNavigation: PrimaryNav,
               primaryFooter: PrimaryFooter,
            },
         },
         {
            path: '/privacy-policy',
            components: {
               default: PrivacyPolicy,
               primaryNavigation: PrimaryNav,
               primaryFooter: PrimaryFooter,
            },
         },
         {
            path: '/admin',
            components: {
               default: Admin,
               // primaryNavigation: PrimaryNav,
               // primaryFooter: PrimaryFooter,
            },
         },
         {
            path: '/download',
            redirect: {
               path: '/download/fusioncharts-suite-xt',
            },

            components: {
               default: Download,
               primaryNavigation: PrimaryNav,
               primaryFooter: PrimaryFooter,
            },
            children: [
               {
                  path: 'fusioncharts-suite-xt',
                  beforeEnter() {
                     window.location.href =
                        'https://resources.fusioncharts.com/download-14-days-trial/';
                  },
               },
               {
                  path: 'fusionexport',
                  beforeEnter() {
                     window.location.href =
                        'https://resources.fusioncharts.com/download-14-days-trial/';
                  },
               },
               {
                  path: 'map-definition-files',
                  beforeEnter() {
                     window.location.href =
                        'https://resources.fusioncharts.com/download-14-days-trial/';
                  },
               },
               {
                  path: 'fusiontime',
                  beforeEnter() {
                     window.location.href =
                        'https://resources.fusioncharts.com/download-14-days-trial/';
                  },
               },
               {
                  path: 'themes',
                  beforeEnter() {
                     window.location.href =
                        'https://resources.fusioncharts.com/download-14-days-trial/';
                  },
               },
               {
                  path: 'fusiongrid',
                  beforeEnter() {
                     window.location.href =
                        'https://resources.fusioncharts.com/download-14-days-trial/';
                  },
               },
            ],
         },
         {
            path: '/download/whitepaper/:slug',
            components: {
               default: WhitepaperTemplate,
               primaryNavigation: PrimaryNav,
               primaryFooter: PrimaryFooter,
            },
         },
         {
            path: '/downloads/whitepaper/:slug',
            components: {
               default: WhitepaperTemplatePdf,
               primaryNavigation: PrimaryNav,
               primaryFooter: PrimaryFooter,
            },
         },
         {
            path: '/download/trial-thank-you-FCsuiteXT',
            components: {
               default: TrialThankYouSuite,
               primaryNavigation: PrimaryNav,
               primaryFooter: PrimaryFooter,
            },
         },
         {
            path: '/download/trial-thank-you-FCTime',
            components: {
               default: TrialThankYouTime,
               primaryNavigation: PrimaryNav,
               primaryFooter: PrimaryFooter,
            },
         },
         {
            path: '/download/trial-thank-you-FCGrid',
            components: {
               default: TrialThankYouGrid,
               primaryNavigation: PrimaryNav,
               primaryFooter: PrimaryFooter,
            },
         },
         {
            path: '/download/trial-thank-you-FCExport',
            components: {
               default: TrialThankYouExport,
               primaryNavigation: PrimaryNav,
               primaryFooter: PrimaryFooter,
            },
         },
         {
            path: '/download/trial-thank-you-FCExport',
            components: {
               default: TrialThankYouGrid,
               primaryNavigation: PrimaryNav,
               primaryFooter: PrimaryFooter,
            },
         },
         {
            path: '/showcase/fusiontime',
            components: {
               default: FusionTimeDemo,
               primaryNavigation: PrimaryNav,
            },
         },
         {
            path: '/partners',
            components: {
               default: Partners,
               primaryNavigation: PrimaryNav,
               primaryFooter: PrimaryFooter,
            },
         },
         {
            path: '/partners/resellers/faqs',
            components: {
               default: ResellersFaqs,
               primaryNavigation: PrimaryNav,
               primaryFooter: PrimaryFooter,
            },
         },
         {
            name: 'integrations',
            path: '/integrations',
            components: {
               default: IntegrationsOverview,
               primaryNavigation: PrimaryNav,
               primaryFooter: PrimaryFooter,
               sideBar: SideBar,
            },
         },
         {
            name: 'angular-js-charts',
            path: '/angular-js-charts',
            components: {
               default: IntegrationsDetails,
               primaryNavigation: PrimaryNav,
               primaryFooter: PrimaryFooter,
               sideBar: SideBar,
            },
            props: {
               default: {
                  stack: 'front-end-integrations',
                  language: 'angular-js',
               },
            },
         },
         {
            name: 'integrations/details/angular',
            path: '/angular2-js-charts',
            components: {
               default: IntegrationsDetails,
               primaryNavigation: PrimaryNav,
               primaryFooter: PrimaryFooter,
               sideBar: SideBar,
            },
            props: {
               default: {
                  stack: 'front-end-integrations',
                  language: 'angular',
               },
            },
         },
         {
            name: 'integrations/details/react',
            path: '/react-charts',
            components: {
               default: IntegrationsDetails,
               primaryNavigation: PrimaryNav,
               primaryFooter: PrimaryFooter,
               sideBar: SideBar,
            },
            props: {
               default: {
                  stack: 'front-end-integrations',
                  language: 'react',
               },
            },
         },
         {
            name: 'integrations/details/vue',
            path: '/vue-js-charts',
            components: {
               default: IntegrationsDetails,
               primaryNavigation: PrimaryNav,
               primaryFooter: PrimaryFooter,
               sideBar: SideBar,
            },
            props: {
               default: {
                  stack: 'front-end-integrations',
                  language: 'vue',
               },
            },
         },
         {
            name: 'integrations/details/react-native',
            path: '/jquery-charts',
            components: {
               default: IntegrationsDetails,
               primaryNavigation: PrimaryNav,
               primaryFooter: PrimaryFooter,
               sideBar: SideBar,
            },
            props: {
               default: {
                  stack: 'front-end-integrations',
                  language: 'jquery',
               },
            },
         },
         {
            name: 'integrations/details/ember',
            path: '/ember-charts',
            components: {
               default: IntegrationsDetails,
               primaryNavigation: PrimaryNav,
               primaryFooter: PrimaryFooter,
               sideBar: SideBar,
            },
            props: {
               default: {
                  stack: 'front-end-integrations',
                  language: 'ember',
               },
            },
         },
         /* {
            name: 'blazor',
            path: '/blazor',
            components: {
               default: BlazorIntegrationsDetails,
            },
         }, */
         {
            name: 'integrations/details/flutter',
            path: '/flutter',
            components: {
               default: FlutterIntegrationsDetails,
               primaryNavigation: PrimaryNav,
               primaryFooter: PrimaryFooter,
               sideBar: SideBar,
            },
            props: {
               default: {
                  stack: 'front-end-integrations',
                  language: 'flutter',
               },
            },
         },
         {
            name: 'integrations/details/jquery',
            path: '/react-native-charts',
            components: {
               default: IntegrationsDetails,
               primaryNavigation: PrimaryNav,
               primaryFooter: PrimaryFooter,
               sideBar: SideBar,
            },
            props: {
               default: {
                  stack: 'front-end-integrations',
                  language: 'react-native',
               },
            },
         },
         {
            name: 'integrations/details/svelte',
            path: '/svelte-charts',
            components: {
               default: IntegrationsDetails,
               primaryNavigation: PrimaryNav,
               primaryFooter: PrimaryFooter,
               sideBar: SideBar,
            },
            props: {
               default: {
                  stack: 'front-end-integrations',
                  language: 'svelte',
               },
            },
         },
         {
            name: 'integrations/details/asp',
            path: '/asp-net-charts',
            components: {
               default: IntegrationsDetails,
               primaryNavigation: PrimaryNav,
               primaryFooter: PrimaryFooter,
               sideBar: SideBar,
            },
            props: {
               default: {
                  stack: 'back-end-integrations',
                  language: 'asp',
               },
            },
         },
         {
            name: 'integrations/details/php',
            path: '/php-charts',
            components: {
               default: IntegrationsDetails,
               primaryNavigation: PrimaryNav,
               primaryFooter: PrimaryFooter,
               sideBar: SideBar,
            },
            props: {
               default: {
                  stack: 'back-end-integrations',
                  language: 'php',
               },
            },
         },
         {
            name: 'integrations/details/ruby-on-rails',
            path: '/ruby-on-rails-charts',
            components: {
               default: IntegrationsDetails,
               primaryNavigation: PrimaryNav,
               primaryFooter: PrimaryFooter,
               sideBar: SideBar,
            },
            props: {
               default: {
                  stack: 'back-end-integrations',
                  language: 'ruby-on-rails',
               },
            },
         },
         {
            name: 'integrations/details/django',
            path: '/django-charts',
            components: {
               default: IntegrationsDetails,
               primaryNavigation: PrimaryNav,
               primaryFooter: PrimaryFooter,
               sideBar: SideBar,
            },
            props: {
               default: {
                  stack: 'back-end-integrations',
                  language: 'django',
               },
            },
         },
         {
            name: 'integrations/details/java',
            path: '/java-charts',
            components: {
               default: IntegrationsDetails,
               primaryNavigation: PrimaryNav,
               primaryFooter: PrimaryFooter,
               sideBar: SideBar,
            },
            props: {
               default: {
                  stack: 'back-end-integrations',
                  language: 'java',
               },
            },
         },
         {
            name: 'charts-guide-line-charts',
            path: '/line-charts',
            components: {
               default: ChartGuideDetails,
               primaryNavigation: PrimaryNav,
               primaryFooter: PrimaryFooter,
               sideBar: SideBar,
            },
            props: {
               default: {
                  sidebarClass: 'chart-guide',
                  chartGuide: 'line-charts',
               },
            },
         },
         {
            name: 'charts-guide-area-charts',
            path: '/area-charts',
            components: {
               default: ChartGuideDetails,
               primaryNavigation: PrimaryNav,
               primaryFooter: PrimaryFooter,
               sideBar: SideBar,
            },
            props: {
               default: {
                  sidebarClass: 'chart-guide',
                  chartGuide: 'area-charts',
               },
            },
         },
         {
            name: 'charts-guide-bar-charts',
            path: '/bar-charts',
            components: {
               default: ChartGuideDetails,
               primaryNavigation: PrimaryNav,
               primaryFooter: PrimaryFooter,
               sideBar: SideBar,
            },
            props: {
               default: {
                  sidebarClass: 'chart-guide',
                  chartGuide: 'bar-charts',
               },
            },
         },
         {
            name: 'charts-guide-column-charts',
            path: '/column-charts',
            components: {
               default: ChartGuideDetails,
               primaryNavigation: PrimaryNav,
               primaryFooter: PrimaryFooter,
               sideBar: SideBar,
            },
            props: {
               default: {
                  sidebarClass: 'chart-guide',
                  chartGuide: 'column-charts',
               },
            },
         },
         {
            path: '/demo/:category?/:id?',
            components: {
               default: DemoGallery,
               primaryNavigation: PrimaryNav,
               primaryFooter: PrimaryFooter,
            },
         },
         {
            path: '*',
            components: {
               default: NotFound,
               primaryNavigation: PrimaryNav,
               primaryFooter: PrimaryFooter,
            },
         },
      ],
   });
}
